import {createJsonStore} from "./json-store";
import {UseState} from "./use-state";
import {cs} from "./chain-services";
import {Types} from "../types";

export const StorageState = <Value,>({key, defaultValue=undefined, storage, next}:{
    key           : string,
    defaultValue ?: Value,
    storage       : Storage,
    next          : (v:Types.Common.React.StorageState.Next<Value>) => JSX.Element,
}) => {
    const access = createJsonStore(key, storage);
    return cs(
        ["v", (_, next) => UseState({
            getInitValue: () => access.get() || defaultValue,
            next,
        })],
        ({v}) => next({
            value: v.value,
            onChange: (v1) => {
                access.set(v1);
                v.onChange(v1);
            },
            change: (reduceValue: (v:any) => any, cb: () => void) => {
                const v1 = reduceValue(access.get());
                access.set(v1);
                v.onChange(v1, cb);
            }
        })
    );
};
